import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=901e805a&scoped=true"
import script from "./addDialog.vue?vue&type=script&lang=js"
export * from "./addDialog.vue?vue&type=script&lang=js"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=901e805a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901e805a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('901e805a')) {
      api.createRecord('901e805a', component.options)
    } else {
      api.reload('901e805a', component.options)
    }
    module.hot.accept("./addDialog.vue?vue&type=template&id=901e805a&scoped=true", function () {
      api.rerender('901e805a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/goods_manage/addDialog.vue"
export default component.exports